import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import { cn } from "@/shared/lib/cn";

type DashboardMetricCardProps = {
  title: string;
  value: string;
  footer: ReactNode;
  icon: React.ComponentType<{ size?: number; className?: string; strokeWidth?: number }>;
  cardClassName: string;
  iconClassName: string;
  valueClassName?: string;
  titleClassName?: string;
  footerClassName?: string;
  href?: string;
};

export function DashboardMetricCard({
  title,
  value,
  footer,
  icon: Icon,
  cardClassName,
  iconClassName,
  valueClassName,
  titleClassName,
  footerClassName,
  href,
}: DashboardMetricCardProps) {
  const content = (
    <>
      <div className="flex items-start justify-between gap-3">
        <div className={cn("flex h-12 w-12 shrink-0 items-center justify-center", iconClassName)}>
          <Icon size={22} strokeWidth={2} />
        </div>
        <p className={cn("text-3xl font-bold tabular-nums text-foreground", valueClassName)}>
          {value}
        </p>
      </div>
      <p className={cn("mt-3 text-sm font-medium text-foreground", titleClassName)}>{title}</p>
      <p className={cn("mt-1 flex w-full items-center gap-1.5 text-xs text-muted", footerClassName)}>
        {footer}
      </p>
    </>
  );

  const cardClasses = cn(
    "theme-card cursor-pointer p-5 transition-all hover:shadow-[var(--shadow-sm)]",
    cardClassName,
  );

  if (href) {
    return (
      <Link to={href} className={cn("block", cardClasses)}>
        {content}
      </Link>
    );
  }

  return <div className={cardClasses}>{content}</div>;
}
